































































































































































import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons/faShoppingBag';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons/faUserCircle';

import bButton from 'bootstrap-vue/es/components/button/button';
import bDropdown from 'bootstrap-vue/es/components/dropdown/dropdown';
import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item';
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input';
import bCol from 'bootstrap-vue/es/components/layout/col';
import bInputGroup from 'bootstrap-vue/es/components/input-group/input-group';
import bInputGroupAppend from 'bootstrap-vue/es/components/input-group/input-group-addon';
import bContainer from 'bootstrap-vue/es/components/layout/container';
import bLink from 'bootstrap-vue/es/components/link/link';
import bRow from 'bootstrap-vue/es/components/layout/row';
import bNavbar from 'bootstrap-vue/es/components/navbar/navbar';
import bNavbarBrand from 'bootstrap-vue/es/components/navbar/navbar-brand';
import bPopover from 'bootstrap-vue/es/components/popover/popover';

import DEMO_DATA from '@/demo-data';

import Cart from './Cart.vue';
import Logo from './Logo';
import NavLink from './NavLink.vue';
import NavMegaMenu from './NavMegaMenu.vue';
import TopHeader from './TopHeader.vue';

const LargeNavbarProps = Vue.extend({
  props: {
    logo: {
      type: Object as () => Logo,
      required: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
});

@Component({
  components: {
    Cart,
    FontAwesomeIcon,
    NavLink,
    NavMegaMenu,
    TopHeader,

    bButton,
    bCol,
    bContainer,
    bDropdown,
    bDropdownItem,
    bFormInput,
    bInputGroup,
    bInputGroupAppend,
    bLink,
    bNavbar,
    bNavbarBrand,
    bPopover,
    bRow,
  },
})
export default class LargeNavbar extends LargeNavbarProps {
  public readonly faSearch = faSearch;
  public readonly faShoppingBag = faShoppingBag;
  public readonly faUserCircle = faUserCircle;
  public readonly collections = DEMO_DATA.menu;
  public readonly cartProducts = DEMO_DATA.cart;
  public showCartPopover = false;

  @Watch('showCartPopover')
  public onCartPopoverShown() {
    if (this.showCartPopover) {
      this.$root.$emit('bv::disable::popover', 'cart-popover-trigger');
    } else {
      this.$root.$emit('bv::enable::popover', 'cart-popover-trigger');
    }
  }
}

